var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYesHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_88_142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.0645 47.6441C29.5657 47.6441 29.218 47.3569 28.9006 47.0395C24.774 42.913 20.6626 38.8016 16.5361 34.675C15.7501 33.889 15.6745 33.0577 16.264 32.4682C16.8837 31.8484 17.6395 31.9089 18.4558 32.7251C22.0684 36.3226 25.681 39.905 29.2482 43.5327C29.9133 44.2129 30.2912 44.228 30.9714 43.5327C37.6827 36.7761 44.4242 30.0497 51.1658 23.3081C52.2238 22.2501 52.9947 22.0536 53.6749 22.6884C54.4005 23.3686 54.2493 24.1093 53.1005 25.258C45.9509 32.4077 38.7861 39.5724 31.6365 46.7221C31.1981 47.1604 30.79 47.6744 30.0645 47.629V47.6441Z",
    fill: "#C5A900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9924 70C15.705 70 0 54.295 0 34.9924C0 15.6899 15.705 0 34.9924 0C54.2799 0 69.9849 15.705 69.9849 34.9924C69.9849 54.2799 54.2799 69.9849 34.9924 69.9849V70ZM34.9924 2.26733C16.9445 2.26733 2.26733 16.9445 2.26733 34.9924C2.26733 53.0404 16.9445 67.7176 34.9924 67.7176C53.0404 67.7176 67.7176 53.0404 67.7176 34.9924C67.7176 16.9445 53.0404 2.26733 34.9924 2.26733Z",
    fill: "#C5A900"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_88_142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYesHover);
export default __webpack_public_path__ + "static/media/yes-hover.4c69a5249dc776c14f27beb5f95bf753.svg";
export { ForwardRef as ReactComponent };